


import React, { useEffect, useState } from 'react';
import axios from "axios";
import { toast } from "react-toastify";
import config from "../../config/config";
import { getAuthToken } from "../../utils/token";
import { Modal, Button, Row, Col, Form } from 'react-bootstrap';
import { formatDate } from "../../utils/formatDate";


const SuperCorrectiveActionReport = ({ show, handleClose, productId }) => {

  const [correctivreport, SetCorrectivreport] = useState([])

  const [formData, setFormData] = useState({
    visual_inspection: false,
    dimensional_check: false,
    quantity_check: false,
    packaging_condition: false,
    material_certificate: false,
    produced_inspected: "",
    produced_passed: "",
    notes: "",
    unit: "",
  });


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };


  const handleSubmit = async () => {
    const token = getAuthToken();
    if (!token) {
      toast.error("Authentication token missing!");
      return;
    }

    const payload = {
      visual_inspection: formData.visual_inspection,
      dimensional_check: formData.dimensional_check,
      quantity_check: formData.quantity_check,
      packaging_condition: formData.packaging_condition,
      material_certificate: formData.material_certificate,
      produced_inspected: Number(formData.produced_inspected) || 0,
      produced_passed: Number(formData.produced_passed) || 0,
      unit: "pcs",
      notes: formData.notes,
    };

    try {
      const response = await axios.post(
        `${config.API}/supervisor/correctiveactionreport/${productId}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data) {
        toast.success(response.data.message || "Report submitted successfully");
        setFormData({
          visual_inspection: "",
          dimensional_check: "",
          quantity_check: "",
          packaging_condition: "",
          material_certificate: "",
          produced_inspected: "",
          produced_passed: "",
          notes: "",
        });
        handleClose();
      }

    } catch (error) {
      if (error.response?.status === 422) {
        const errorsObj = error.response?.data?.errors;

        if (errorsObj) {
          Object.values(errorsObj).forEach((messages) => {
            messages.forEach((msg) => toast.error(msg));
          });
        }
      } else {
        toast.error(error.response?.data?.message || "Something went wrong");
      }
    }
  };


  const fetchGetcorrectiveactionreport = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      const response = await axios?.get(`${config?.API}/supervisor/getcorrectiveactionreport/${productId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response?.data?.success) {
        SetCorrectivreport(response?.data?.product);
      } else {
        SetCorrectivreport([]);
      }
    } catch (err) {
      console.error("Error fetching RejectionReport:", err.message);
      SetCorrectivreport(null);
    }
  };

  useEffect(() => {
    fetchGetcorrectiveactionreport()
  }, [productId])



  return (
    <Modal show={show} onHide={handleClose} centered size="lg" className='font_family'>
      <Modal.Body className='p-5'>
        {/* NC Information */}
        <strong className='fs-4'>Corrective Action Report</strong>
        <div className="p-3 mb-4  bg-light mt-4">

          <Row>
            <Col><strong>Product Name:</strong> {correctivreport?.product?.name}</Col>
            <Col><strong>Product ID:</strong> {correctivreport?.product?.product_code}</Col>
          </Row>
          <Row className="mt-2">
            <Col><strong>Qty NC:</strong>{correctivreport?.nc_count}</Col>
            <Col><strong>Report Date:</strong> {formatDate(correctivreport?.created_at)} </Col>
          </Row>
          <Row className="mt-2">
            <Col><strong>Reported by:</strong> {correctivreport?.user?.name}
              
            </Col>
            <Col><strong>NC Type:</strong> {correctivreport?.reason}</Col>
          </Row>
          <Row className="mt-3">
            <Col></Col>
            <Col>
              <Button variant="" className='btn bg-white'>Review NC Report</Button>
            </Col>
          </Row>
        </div>

        {/* Inspection Checklist */}
        <div className="p-3 mb-4  bg-light">
          <strong>Inspection Checklist</strong>
          <Form.Group>
            <Form.Check
              label="Visual Inspection (No visible defects)"
              name="visual_inspection"
              checked={formData.visual_inspection}
              onChange={handleChange}
            />

            <Form.Check
              label="Dimensional Check (Meets specifications)"
              name="dimensional_check"
              checked={formData.dimensional_check}
              onChange={handleChange}
            />

            <Form.Check
              label="Quantity Check (Matches delivery note)"
              name="quantity_check"
              checked={formData.quantity_check}
              onChange={handleChange}
            />

            <Form.Check
              label="Packaging Condition (No damage)"
              name="packaging_condition"
              checked={formData.packaging_condition}
              onChange={handleChange}
            />

            <Form.Check
              label="Material Certificate (Provided and valid)"
              name="material_certificate"
              checked={formData.material_certificate}
              onChange={handleChange}
            />

          </Form.Group>
        </div>

        {/* Inspection Results */}
        <Row className="mb-3">
          <Col md={3}>
            <Form.Label><strong>Producted Inspected</strong></Form.Label>
          </Col>
          <Col md={3}>
            <div className="d-flex align-items-center">
              <Form.Control
                type="number"
                name="produced_inspected"
                value={formData.produced_inspected}
                onChange={handleChange}
              />
              <span className="ms-2">pcs</span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <Form.Label><strong>Producted Passed</strong></Form.Label>
          </Col>
          <Col md={3}>
            <div className="d-flex align-items-center">
              <Form.Control
                type="number"
                name="produced_passed"
                value={formData.produced_passed}
                onChange={handleChange}
              />
              <span className="ms-2">pcs</span>
            </div>
          </Col>
        </Row>

        {/* Notes */}
        <Row className='mt-5'>
          <Col md={1}></Col>
          <Col md={2}><Form.Label><strong>Notes</strong></Form.Label></Col>
          <Col md={9}><Form.Control
            as="textarea"
            rows={3}
            name="notes"
            value={formData.notes}
            onChange={handleChange}
          /></Col>
        </Row>
      </Modal.Body>
      <Modal.Footer className='border-0'>
        <Button variant="secondary" onClick={handleClose}>Close</Button>
        <Button variant="dark" onClick={handleSubmit}>Submit</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SuperCorrectiveActionReport;
